import ScriptEditor from '../ui/ScriptEditor';

const BashEditor = ({ state, onChange, readOnly = false }) => {
  const { query } = state.config || {};

  return (
    <ScriptEditor
      label="Query"
      controlId="formNode-query"
      name="query"
      value={query || ''}
      language="sql"
      onChange={(e) => onChange(e, true)}
      readOnly={readOnly}
      aria-label="Query editor"
    />
  );
};

export default BashEditor;
